/*

A simple entry point file to the Firebase module (src/firebase/ folder) by
grouping and exposing all the functionalities from the module to other modules
in one file. Thus it shouldn’t be necessary for other modules in your
application to access any other file than this one to use its functionalities.

*/

// expose the implemented authentication methods
// and the Firebase functionalities itself form your Firebase module
import * as auth from './auth'
import * as firebase from './firebase'

export {
	auth,
	firebase,
}

// That way, consumers (React components in our case) should be only allowed
// to access the index.js file as interface to the whole Firebase module
// (src/firebase/) and should not access the auth or firebase files directly


// WEBPACK FOOTER //
// ./src/common/firebase/index.js